import Vue from 'vue'
import Router from 'vue-router'
import authBlock from '@/components/auth'
import Registration from '@/components/registration'
import RecoveryPassword from '@/components/recovery_password'
import CheckRecoveryPassword from '@/components/check_recovery_password'
import CheckRegistration from '@/components/check_registration'
import Groups from '@/components/groups-list'
import UserCabinet from '@/components/user-cabinet'
import Faucets from '@/components/faucets-list'
import AddFauces from '@/components/add-faucet'
import AddSensor from '@/components/add-sensor'
import Sensors from '@/components/sensors-list'
import GroupSettings from '@/components/group-settings'
import NotificationUsers from '@/components/notification_users'
import History from '@/components/history'
import auth from '@/auth.js'
import SensorSettings from '@/components/sensor-settings'
import FaucetSettings from '@/components/faucet-settings'
import setLocalToken from '@/components/set_local_token'
import axios from 'axios'
import config from '@/config.js'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'auth', component: authBlock, beforeEnter: leaveAuthPage},
    { path: '/registration', name: 'registration', component: Registration, beforeEnter: leaveAuthPage},
    { path: '/recovery-password', name: 'recovery-password', component: RecoveryPassword, beforeEnter: leaveAuthPage},
    { path: '/set-local-token/:local_token', name: 'set-local-token',component: setLocalToken, beforeEnter: setToken },
    { path: '/check-recovery-password/:recovert_code', name: 'check-recovery-password', component: CheckRecoveryPassword, beforeEnter: leaveAuthPage},
    { path: '/check-registration/:code', name: 'check-registration', component: CheckRegistration, beforeEnter: leaveAuthPage},
    { path: '/user-cabinet', name: 'user-cabinet', component: UserCabinet, beforeEnter: requireAuth},
    { path: '/groups-list', name: 'groups-list', component: Groups, beforeEnter: requireAuth },
    { path: '/faucets-list/:id_group', name: 'faucets-list',component: Faucets, beforeEnter: requireAuth },
    { path: '/sensors-list/:id_group', name: 'sensors-list',component: Sensors, beforeEnter: requireAuth },
    { path: '/group-settings/:id_group', name: 'group-settings',component: GroupSettings, beforeEnter: requireAuth },
    { path: '/notification-users/:id_group', name: 'notification-users',component: NotificationUsers, beforeEnter: requireAuth },
    { path: '/history/:id_group', name: 'history',component: History, beforeEnter: requireAuth },
    { path: '/add-faucet/:id_group', name: 'add-faucet',component: AddFauces, beforeEnter: requireAuth },
    { path: '/add-sensor/:id_group', name: 'add-sensor',component: AddSensor, beforeEnter: requireAuth },
    { path: '/sensor-settings/:id_group/:id_sensor', name: 'sensor-settings',component: SensorSettings, beforeEnter: requireAuth },
    { path: '/faucet-settings/:id_group/:id_faucet', name: 'faucet-settings',component: FaucetSettings, beforeEnter: requireAuth }
  ]
})

function requireAuth (to, from, next) {
  if (!auth.loggedIn(to.name)) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
    var fail_check_user_function = function () {
        next({
            path: '/',
            query: { redirect: to.fullPath }
        })
    }
    check_user(fail_check_user_function)
  }
}

function leaveAuthPage (to, from, next) {
  if (!auth.loggedIn()) {
    next()
  } else {
    next({
      path: '/groups-list'
    })
  }
}

function setToken (to, from, next) {
  next()
}

var check_user_interval_set = null
var check_user = function (fail_check_user_function) {
  if (check_user_interval_set) {
    clearInterval(check_user_interval_set);
    check_user_interval_set = null;
  }
  auth.checkUser(fail_check_user_function)
  check_user_interval_set = setInterval(() => {
    auth.checkUser(fail_check_user_function)
  }, 90000);
}



// WEBPACK FOOTER //
// ./src/router/index.js